import styled from 'styled-components';

import { COMMON_COLOR } from 'utils/style';

export const COMMON_VIOLET_COLOR = {
  PURPLE_50: '#f5f3ff',
  PURPLE_100: '#ede9fe',
  PURPLE_200: '#ddd6fe',
  PURPLE_300: '#c4b5fd',
  PURPLE_400: '#a78bfa',
  PURPLE_500: '#8b5cf6',
  PURPLE_600: '#7c3aed',
  PURPLE_700: '#6d28d9',
  PURPLE_800: '#5b21b6',
  PURPLE_900: '#4c1d95',
  PURPLE_950: '#2e1065'
};

export const AIChatBotWrapper = styled.div<{
  open?: boolean;
}>`
  padding: ${({ open }) => (open ? '10px 10px 0 10px' : '0')};
`;

export const AiChatBotBody = styled.div<{
  open?: boolean;
}>`
  background: ${COMMON_COLOR.WHITE};
  box-shadow: 0px 4px 16px 0px #0000001f;
  border: 1px solid #e2e8f0;
  min-width: 380px;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  border-radius: 8px 8px 0 0;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
`;

export const AiChatBotHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid ${COMMON_COLOR.GREY_2};

  * {
    font-family: Roboto;
  }

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    h3 {
      font-weight: 700;
      font-style: Bold;
      font-size: 16px;
      leading-trim: NONE;
      line-height: 24px;
      letter-spacing: 0%;
      margin-bottom: 0;
    }

    span {
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      leading-trim: NONE;
      line-height: 16px;
      letter-spacing: 0%;
      padding: 4px 8px;
      background: ${COMMON_COLOR.GREY_1};
    }
  }

  button {
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
  }
`;
